export const environment = {
  production: false,
  API_URL: "https://ps-api-dev.musea2.azure.ext.gm.com",
  CLIENT_ID : "4d0e172c-f02e-4ae7-bf69-aace86909374",
  AUTHORITY: "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d",
  REDIRECT_URI: "https://ps-frontend-dev.musea2.azure.ext.gm.com"
};